import { Button, Grid2 } from '@mui/material'
import React from 'react'
import Heading from '../../shared/utils/Heading'
import { useNavigate } from 'react-router-dom';

const StudentRegistration = ({content}) => {
   
    const navigate = useNavigate();
    return (
        <Grid2 container spacing={{xs:1,lg:2}} sx={{display:"flex",alignItems:"center"}}>
            <Grid2 children size={{ xs: 12, lg: 7 }}>
                <Heading Heading={content?.data?.subheading} SubHeading={content?.data?.heading} />
            </Grid2>
            <Grid2 size={{ xs: 12, lg: 3.5 }}>
                <Button variant='contained' fullWidth onClick={()=>navigate(content?.data?.buttonUrl)}>{content?.data?.buttonText}</Button>
            </Grid2>

        </Grid2>
    )
}

export default StudentRegistration